// Updated MonthYearFilter and MetricsToolbar logic for reliable month-year filtering

import React, { useRef, useState } from 'react'
import { GridToolbarContainer, GridToolbarDensitySelector, useGridApiContext } from '@mui/x-data-grid-pro'
import { Badge, Box, Typography, useTheme } from '@mui/material'
import { gridToolbarContainerStyles } from '../Organizations/style'
import { StyledGridToolbarQuickFilter } from '../DataGrid/style'
import { useActiveUser } from '../../api/slack/useActiveUser'
import ResetColumnsButton from '../ui/reset-columns-button'
import ResetSortingButton from '../ui/reset-sorting-button'
import ResetFiltersButton from '../ui/reset-filters-button'
import OpenColumnsMenu from '../ui/open-columns-menu'
import OpenFiltersMenu from '../ui/open-filters-menu'
import ExportCsvButton from '../ui/export-csv-button'
import FilterMyDataButton from '../ui/filter-my-data-button'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import { slotProps } from '../DataGrid/style'
import MonthYearFilter from './MonthYearFilter'

const initialSortModel = [
  { field: 'creation_timestamp', sort: 'desc' },
  { field: 'name', sort: 'asc' },
]

const initialVisibilityState = {
  org_uuid: false,
  affiliated: false,
  source: false,
  street: false,
  city: false,
  state: false,
  zip: false,
  cmsUsed: false,
  social: false,
  dealIds: false,
}

const MetricsToolbar = ({
  filterModel,
  visibilityModel,
  sortModel,
  setFilterModel,
  onClearSorting,
  onClearVisibility,
  setSelectedMonth,
  selectedMonth,
  selectedYear,
  setSelectedYear,
}) => {
  const theme = useTheme()
  const quickFilterRef = useRef(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const [isCustomFiltersOpen, setCustomFiltersOpen] = useState(false)
  const [shouldClear, setShouldClear] = useState(false)
  const apiRef = useGridApiContext()

  const { activeUser } = useActiveUser()
  const activeUserName = activeUser?.user?.profile?.real_name || ''

  const handleClearFilters = e => {
    e.preventDefault()
    setFilterModel({ items: [], quickFilterValues: [] })
    setSelectedMonth('')
    setShouldClear(true)
  }

  const handleFilterMyData = () => {
    setFilterModel(prev => ({ ...prev, quickFilterValues: [activeUserName] }))
  }

  const handleOpenColumnsMenu = () => {
    apiRef.current.showPreferences('columns' as any)
  }

  const handleOpenFilterPanel = () => {
    apiRef.current.showFilterPanel()
  }

  const handleExport = () => {
    apiRef.current.exportDataAsCsv()
  }
  const fullMonthValue = selectedYear && selectedMonth ? `${selectedYear}-${selectedMonth}` : ''

  return (
    <GridToolbarContainer sx={gridToolbarContainerStyles}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Box sx={{ display: 'flex', gap: 2, ml: 3, alignItems: 'center' }}>
          <GridToolbarDensitySelector slotProps={slotProps(theme)} />
          <OpenColumnsMenu onOpenColumns={handleOpenColumnsMenu} />
          <OpenFiltersMenu
            onOpenFilters={handleOpenFilterPanel}
            filterModel={filterModel}
            badgeColor={theme.palette.icon.organizations}
          />
          <ExportCsvButton onExport={handleExport} />
          <Typography color="text.warning" ml={3}>
            Under Development
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <MonthYearFilter
            value={fullMonthValue}
            onChange={val => {
              const [year, month] = val.split('-')
              setSelectedYear(year)
              setSelectedMonth(month)
            }}
            availableYears={[2023, 2024, 2025]}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
          />
          <FilterMyDataButton
            icon={<CorporateFareIcon sx={{ fontSize: '30px' }} />}
            filterModel={filterModel}
            onClick={handleFilterMyData}
            label={'My Organizations'}
          />
          <ResetColumnsButton
            visibilityModel={visibilityModel}
            onClearVisibility={onClearVisibility}
            initialVisibilityState={initialVisibilityState}
          />
          <ResetSortingButton isSortModelChanged={!!sortModel.length} onClearSorting={onClearSorting} />
          <ResetFiltersButton filterModel={filterModel} handleClearFilters={handleClearFilters} />
          <Badge
            badgeContent={
              filterModel?.quickFilterValues?.length ? (
                <Typography
                  sx={{
                    fontSize: 12,
                    bgcolor: 'rgb(114, 229, 218)',
                    p: 0.5,
                    height: 20,
                    width: 20,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'black',
                    fontWeight: 'bold',
                  }}
                >
                  {filterModel.quickFilterValues.length}
                </Typography>
              ) : null
            }
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <StyledGridToolbarQuickFilter placeholder="ctrl+f or cmd+f to search" inputRef={quickFilterRef} />
          </Badge>
        </Box>
      </Box>
    </GridToolbarContainer>
  )
}

export default MetricsToolbar
